import { style } from "@vanilla-extract/css";
import { vars } from "../../styles/theme.css";

export const horizontalDividerStyles = style({
  position: "relative",
  margin: 0,
  border: 0,
  textAlign: "center",
  lineHeight: 1,
  fontSize: vars.fontSizes.body.s,

  selectors: {
    "&::before": {
      position: "absolute",
      insetInlineStart: 0,
      backgroundColor: vars.colors.outlineVariant,
      width: "100%",
      height: 1,
      content: "",
    },
    "&::after": {
      position: "relative",
      top: "50%",
      display: "inline-block",
      transform: "translateY(-50%)",
      backgroundColor: vars.colors.surface,
      padding: `0 ${vars.space.xs}`,
      color: vars.colors.onSurfaceVariant,
      fontFamily: vars.fonts.bold,
      fontSize: vars.fontSizes.body.s,
      fontWeight: 400,
      content: "attr(data-content)",
    },
  },
});
